// extracted by mini-css-extract-plugin
module.exports = {"container":"dd31006766--container--3cIYu","right":"dd31006766--right--2TB8K"};